import _ from 'underscore';
import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import cx from 'classnames';

import Icon from 'components/Icon';

import { setInclusivePanelAttributes } from 'components/Modal';
import { PVIContext } from 'contexts/PVIContext';
import styles from './styles.module.scss';

const FilterModal = ({
	children,
	modalStatus,
	label,
	closeHandler,
	className
}) => {
	const { panelActive } = useContext(PVIContext);
	useEffect(() => {
		if (modalStatus) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflowX = 'hidden';
			document.body.style.overflowY = 'scroll';
		}
		return () => {
			document.body.style.overflowX = 'hidden';
			document.body.style.overflowY = 'scroll';
		};
	}, [modalStatus]);

	const modalRef = useRef(null);
	useEffect(() => {
		if (modalRef?.current && panelActive) {
			setInclusivePanelAttributes(modalRef);
		}
	}, [modalRef, panelActive]);

	return ReactDOM.createPortal(
		<>
			<div
				ref={modalRef}
				className={cx('pvi-body', styles.modal, className, {
					[styles.show]: modalStatus
				})}
			>
				<div className={styles.modalHeader}>
					<div className={styles.title}>{label}</div>
					{/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
					<button
						type="button"
						onClick={closeHandler}
						className={styles.closeBtn}
					>
						<Icon icon="close" className={styles.closeIcon} />
					</button>
				</div>
				{children}
			</div>
			<div
				className={cx(styles.overlay, {
					[styles.show]: modalStatus
				})}
			></div>
		</>,
		document.body
	);
};

FilterModal.propTypes = {
	children: PropTypes.node,
	modalStatus: PropTypes.bool,
	switchFilter: PropTypes.func,
	modalHandler: PropTypes.func,
	filterTitle: PropTypes.string,
	className: PropTypes.string
};

FilterModal.defaultProps = {
	switchFilter: _.noop,
	modalHandler: _.noop,
	filterTitle: null,
	label: 'Фильтры'
};

export default FilterModal;
